export interface PaginationParams {
  page: number;
  pageSize: number;
}

export interface SortParams {
  sortBy: string;
  sortDesc: boolean;
}

export interface PaginationInfo {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface PaginatedResponse<T> {
  items: T[];
  pagination: PaginationInfo;
}

/**
 * RFC 9457 problem details envelope returned by Foxit Commerce API for 4xx/5xx responses
 * (Content-Type: application/problem+json).
 *
 * See https://datatracker.ietf.org/doc/html/rfc9457.
 *
 * The OAuth /oauth2/token endpoint continues to use the RFC 6749 envelope and is not represented
 * by this type.
 */
export interface ProblemDetails {
  /** URI identifying the problem type. Resolves to a human-readable documentation page. */
  type: string;
  /** Short, constant human-readable summary of the problem type. */
  title: string;
  /** HTTP status code for this occurrence. */
  status: number;
  /** Per-occurrence human-readable explanation. */
  detail?: string;
  /** Per-occurrence identifier of the form `/requests/{requestId}`. */
  instance?: string;
  /** Extension member: per-field or per-occurrence error messages. */
  errors?: string[];
  /** Extension member: ISO 8601 timestamp when the error was generated. */
  timestamp?: string;
}

/**
 * Returns the machine-readable error code derived from the {@link ProblemDetails.type} URI suffix.
 * Example: `https://commerce-developers.foxit.com/errors/validation-error` -> `VALIDATION_ERROR`.
 */
export function getErrorCode(problem: ProblemDetails): string {
  const typeUri = problem.type ?? '';
  const lastSlash = typeUri.lastIndexOf('/');
  const slug = lastSlash >= 0 ? typeUri.slice(lastSlash + 1) : typeUri;
  return slug.replace(/-/g, '_').toUpperCase();
}

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

